import _filter from "lodash/filter"
import _includes from "lodash/includes"
import _map from "lodash/map"

export const prepareCountsPosPaid = ({ keys, productSelected, invoices }) => {
  const { paymentMode } = productSelected

  const payload = {
    fileType: "PHONE_DETAILS",
    invoiceId: null,
    paymentMode,
    systemBilling: "KENAN",
    format: "PDF"
  }

  const invoicePos2 = _filter(invoices, (invoice) =>
    _includes(invoice.dueDate, keys)
  )
  const payloads = _map(invoicePos2, (inv) => {
    return {
      ...payload,
      invoiceId: inv.id,
      monthYear: [formatDateToMonthYear(inv.dueDate)]
    }
  })

  return payloads
}

const formatDateToMonthYear = (value) => `${value.substr(3)}`



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/prepareCountsPosPaid.js